export const TYPE_CONTACTS = 1
